import { render, staticRenderFns } from "./EmployeeView.vue?vue&type=template&id=6868ef8e&scoped=true"
import script from "./EmployeeView.vue?vue&type=script&lang=js"
export * from "./EmployeeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868ef8e",
  null
  
)

export default component.exports